enum Roles {
  Admin = 'admin',
}

export default Roles;
